// Instagram account type (Personal / Creator / Business) as a small badge or a label.
// Creator + business are "professional" accounts: they get insights (reach, views, profile visits).

import type { IgAccountType } from "@gf/shared";
import { Badge } from "@gf/ui";
import { Briefcase, Sparkles, User } from "lucide-react";

export const ACCOUNT_TYPE_LABELS: Record<IgAccountType, string> = {
  personal: "Personal",
  creator: "Creator",
  business: "Business",
};

export function accountTypeLabel(t: IgAccountType | null | undefined): string {
  return ACCOUNT_TYPE_LABELS[t ?? "personal"] ?? "Personal";
}

export function AccountTypeBadge({ type, size = "sm" }: { type: IgAccountType | null | undefined; size?: "sm" | "md" }) {
  const t = type ?? "personal";
  const icon = t === "business" ? <Briefcase size={11} /> : t === "creator" ? <Sparkles size={11} /> : <User size={11} />;
  return (
    <Badge
      size={size}
      tone={t === "personal" ? "neutral" : "info"}
      icon={icon}
      title={t === "personal" ? "Personal account — no Instagram insights" : `${ACCOUNT_TYPE_LABELS[t]} account — Instagram insights available`}
    >
      {ACCOUNT_TYPE_LABELS[t]}
    </Badge>
  );
}
